<template>
  <div class="payroll__submit">
    <div class="success-container">
      <div class="payroll_submit--image">
        <svg width="96" height="96">
          <image
            xlink:href="../../../assets/images/payroll_success_checked.svg"
            src="../../../assets/images/payroll_success_checked.png"
            width="96"
            height="96"
          />
        </svg>
      </div>
      <div class="payroll__submit--message">
        <div class="payroll_submit--message-text-status">
          <h3>Payments queued successfully</h3>
          <p>
            You can check the status of transactions in the
            <router-link to="/payroll">Payroll History</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayrollSuccess",

  data() {
    return {
      home: true,
      userName: "",
      debited: false,
      pays: false,
      date: null,
      month: null,
      year: null,
      debitedAmount: 0,
      compensationTotal: 0,
      transactionCost: 0,
      payrollId: null,
    };
  },
  methods: {
    openHomeTable() {
      this.home = true;
      this.debited = false;
      this.pays = false;
    },
    openDebitedTable() {
      this.home = false;
      this.debited = true;
      this.pays = false;
    },
    openPaysTable() {
      this.home = false;
      this.debited = false;
      this.pays = true;
    },
    gotoTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.gotoTop();
    this.date = this.$store.state.payrollDate;
    this.month = this.$store.state.payrollMonth;
    this.year = this.$store.state.payrollYear;
  },
  created() {
    let user = this.$store.getters.currentAuthUser;
    this.userName = user.firstname;

    if (Object.keys(this.$store.state.breakdownPayroll).length === 0) {
      return;
    }

    this.payrollId = this.$store.state.breakdownPayroll.payroll_id;

    this.debitedAmount = this.$store.state.amountDebited
      .toFixed(2)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    this.compensationTotal = this.$store.state.compensationTotal
      .toFixed(2)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    this.transactionCost = this.$store.state.transactionCost
      .toFixed(2)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  },
};
</script>

<style lang="scss" scoped>
.payroll_submit--message-text-status {
  margin-top: 20px;
}

.payroll__submit {
  margin-top: 20px;
  padding-bottom: 200px;
  padding-top: 20px;
  padding-left: 9.427vw;
  padding-right: 9.427vw;

  > .payroll__submit--message {
    overflow: hidden;
    padding: 20px 0 0 0;
    text-align: center;

    > span {
      font-size: 2.083vw;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 0.75;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > p {
      font-size: 1.25vw;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      max-width: 800px;
      margin: 20px auto 0 auto;

      > span {
        font-weight: normal;
        color: #5099de;
      }
    }

    > div {
      max-width: 700px;
      margin: 30px auto 10px auto;
      overflow: hidden;

      > div {
        width: 33.33333333%;
        float: left;

        > span {
          font-size: 1.25vw;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
        }

        > p {
          font-size: 1.25vw;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          font-weight: 200;
        }
      }
    }
  }

  > .payroll__submit--error {
    color: red;
    text-align: center;
    font-style: italic;
    margin-bottom: 10px;
    font-size: 12px;
  }

  > .payroll__submit--btn {
    width: 300px;
    margin: 0 auto 20px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    > .payroll__submit--btn-pay {
      width: 45%;
      height: 40px;
      min-width: 100px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #5099de;
      border: 1px solid #5099de;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }

    > .payroll__submit--btn-cancel {
      width: 45%;
      height: 40px;
      min-width: 100px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #5099de;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #000;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }
  }

  > .payroll__submit--image {
    width: 46.198vw;
    margin: 0 auto;
  }

  > .payroll__submit--links {
    margin-top: 120px;

    > div {
      text-align: left;

      span {
        font-size: 1.25vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        cursor: pointer;
        color: #5099de;
      }

      > p {
        font-size: 1.25vw;
        font-weight: 200;
        max-width: 800px;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.46;
        letter-spacing: normal;
        color: #000000;
      }
    }
  }

    .success-container {
      text-align: center;
      width: 50%;
      margin: 0 auto;
      margin-top: 100px;
      display: flex;
      flex-direction: column;

      > .payroll__submit--image {
        width: 100px;
        height: 100px;
        background-color: F2F7F2;
      }

      > .payroll__submit--message {
        color: #000000;

        > .payroll__submit--message-text-status {
          > h3 {
            font-size: 1.245vw;
          }

          > p {
            font-size: 1.0249vw;
          }
        }
        > .payroll__submit--message-text-amount {
          > p {
            font-size: 1.0249vw;
          }
        }
        > .payroll__submit--message-text-amount {
          > p {
            font-size: 1.0249vw;
          }

          > :nth-child(1) {
            font-size: 1.098vw;
            font-weight: 700;
          }
        }
      }
    }
  
}
</style>